/**
 * Inline SVG icon set reused across the workflow shell, dashboard card
 * strip, and Test Drive page. Lifted from HomePage.js so the in-app cards
 * match the marketing page visually.
 */
import React from 'react';

const stroke = {
  fill: 'none',
  stroke: 'currentColor',
  strokeWidth: 1.8,
  strokeLinecap: 'round',
  strokeLinejoin: 'round',
};

export const Icon = {
  spark: (p) => (
    <svg viewBox="0 0 24 24" {...stroke} {...p}>
      <path d="M12 3l2.2 5.3L20 10.5l-5.8 2.2L12 18l-2.2-5.3L4 10.5l5.8-2.2z" />
    </svg>
  ),
  shield: (p) => (
    <svg viewBox="0 0 24 24" {...stroke} {...p}>
      <path d="M12 3l7 3v6c0 4.4-3 7.6-7 9-4-1.4-7-4.6-7-9V6z" />
      <path d="M9 12l2 2 4-4" />
    </svg>
  ),
  doc: (p) => (
    <svg viewBox="0 0 24 24" {...stroke} {...p}>
      <path d="M14 3H7a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V8z" />
      <path d="M14 3v5h5" />
      <path d="M9 13h6M9 17h6" />
    </svg>
  ),
  checkCircle: (p) => (
    <svg viewBox="0 0 24 24" {...stroke} {...p}>
      <circle cx="12" cy="12" r="9" />
      <path d="M8.5 12.5l2.4 2.4 4.6-5" />
    </svg>
  ),
  code: (p) => (
    <svg viewBox="0 0 24 24" {...stroke} {...p}>
      <path d="M8 8l-4 4 4 4M16 8l4 4-4 4M13 6l-2 12" />
    </svg>
  ),
  key: (p) => (
    <svg viewBox="0 0 24 24" {...stroke} {...p}>
      <circle cx="8" cy="8" r="4" />
      <path d="M11 11l9 9" />
      <path d="M16 16l2-2M19 19l2-2" />
    </svg>
  ),
  chart: (p) => (
    <svg viewBox="0 0 24 24" {...stroke} {...p}>
      <path d="M4 20V10M10 20V4M16 20v-7M22 20H2" />
    </svg>
  ),
  rocket: (p) => (
    <svg viewBox="0 0 24 24" {...stroke} {...p}>
      <path d="M14 4s5 .5 5 5c0 4.5-7 11-7 11s-6.5-6.5-6.5-11c0-4.5 5-5 5-5z" />
      <circle cx="12" cy="9" r="1.5" />
      <path d="M9 16l-3 4 4-3M15 16l3 4-4-3" />
    </svg>
  ),
  arrow: (p) => (
    <svg viewBox="0 0 24 24" {...stroke} strokeWidth={2} {...p}>
      <path d="M5 12h14M13 6l6 6-6 6" />
    </svg>
  ),
  check: (p) => (
    <svg viewBox="0 0 24 24" {...stroke} strokeWidth={2} {...p}>
      <path d="M20 6L9 17l-5-5" />
    </svg>
  ),
  upload: (p) => (
    <svg viewBox="0 0 24 24" {...stroke} {...p}>
      <path d="M12 17V5" />
      <path d="M7 10l5-5 5 5" />
      <path d="M5 21h14" />
    </svg>
  ),
  download: (p) => (
    <svg viewBox="0 0 24 24" {...stroke} {...p}>
      <path d="M12 3v12" />
      <path d="M7 10l5 5 5-5" />
      <path d="M5 21h14" />
    </svg>
  ),
  chat: (p) => (
    <svg viewBox="0 0 24 24" {...stroke} {...p}>
      <path d="M21 15a2 2 0 0 1-2 2H8l-5 4V6a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" />
    </svg>
  ),
  copy: (p) => (
    <svg viewBox="0 0 24 24" {...stroke} {...p}>
      <rect x="9" y="9" width="11" height="11" rx="2" />
      <path d="M5 15V5a2 2 0 0 1 2-2h10" />
    </svg>
  ),
  send: (p) => (
    <svg viewBox="0 0 24 24" {...stroke} {...p}>
      <path d="M22 2L11 13" />
      <path d="M22 2l-7 20-4-9-9-4z" />
    </svg>
  ),
  play: (p) => (
    <svg viewBox="0 0 24 24" {...stroke} {...p}>
      <path d="M7 5l12 7-12 7z" />
    </svg>
  ),
  close: (p) => (
    <svg viewBox="0 0 24 24" {...stroke} strokeWidth={2} {...p}>
      <path d="M6 6l12 12M18 6L6 18" />
    </svg>
  ),
};

export default Icon;
